import React, { useState } from "react";
// import "react-date-range/dist/styles.css"; // main style file
// import "react-date-range/dist/theme/default.css"; // theme css file
import Calendar from "react-calendar";
import "./dashboarddatepicker.scss";
import moment from "moment";
import dateFormat from "dateformat";

export default function DashboardDatePicker(props) {
  const { tileContent, onCalendarMonthChange, loader } = props;
  const [date, setDate] = useState(new Date());

  const handleDateChange = (date) => {
    setDate(date);
    props.dateInputCallBack(date);
  };

  return (
    <div
      className={`appointment-date-ranges dashboard_position`}
      style={{ zIndex: "9999" }}
    >
      <div
        className={`calendar-loader-highlighted-wrapper-box ${
          loader ? "disable-highlight" : ""
        }`}
      >
        <div className="calendar-loader-wrapper-box">
          {loader && (
            <div className={"calendar-container calendar-loader-wrapper-box"}>
              <div className="calendar-loader calendar-loader-wrapper-box">
                <div class="spinner-border text-dark" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          )}
          <Calendar
            onChange={handleDateChange}
            value={date}
            maxDate={
              props?.maxDate
                ? props?.maxDate
                : moment(new Date()).add(12, "months")._d
            }
            minDate={props?.minDate}
            tileContent={tileContent}
            onActiveStartDateChange={({ activeStartDate }) => {
              onCalendarMonthChange(
                dateFormat(new Date(activeStartDate), "yyyy-mm-dd")
              );
            }}
          />
        </div>
      </div>
    </div>
  );
}
